<template lang="pug">
  div
    header-without-menu
    b-container.content.page-container
      b-row.header
        img(src="../../../assets/logo_big.svg")
      b-row.select-mode
        div.partner-mode.centered-content(@click="handlePartnerModeClick")
          span 파트너 원격
        div.temporary-mode.centered-content(@click="handleTemporaryModeClick")
          span 이메일 초대 원격
      b-row.mode-explanation
        div.centered-content
          span 협력사 및 임시 사용자 전용
        div.centered-content
          span 일회성 초대 코드 입력
      b-row.footer
        div.centered-content
          span COPYRIGHT 20232. KOINO Inc. all rights reserved.

</template>

<script>
import { HeaderWithoutMenu } from '../../mixins/header'

export default {
  name: 'temporary-index',
  components: {HeaderWithoutMenu},
  methods: {
    handlePartnerModeClick() {
      this.$router.push('partner-login')
    },
    handleTemporaryModeClick() {
      this.$router.push('email-invitation')
    },
  },
  mounted() {
    // console.log("temporary-login Mounted")
  },
  data() {
    return {

    }
  }
}
</script>


<style scoped lang="scss">
.page-container {
  padding-top: 7rem;
}

.header {
  justify-content: center;
  margin-bottom: 2rem;
  > img {
    width: 17rem;
  }
}

.select-mode {
  justify-content: center;
  > div {
    width: 25rem;
    height: 25rem;
    margin: 1rem;
    border-radius: 5rem;
    cursor: pointer;
    > span {
      color: white;
      font-size: 2rem;
      font-weight: 500;
    }
  }
}

.partner-mode {
  background: #fd7e14;
}

.temporary-mode {
  background: #7d7d7d;
}

.mode-explanation {
  justify-content: center;
  margin-top: 0.5rem;
  > div {
    width: 25rem;
    margin: 0 1rem;
  }
  span {
    font-size: 1.2rem ;
  }
}

.centered-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer {
  justify-content: center;
  margin-top: 10rem;
  span {
    font-size: 0.9rem;
    font-weight: 350;
    letter-spacing: 2px;
  }
}
</style>
